export const systemKeys = {
  all: ["systems"] as const,
  systems: (projectId: string) => [...systemKeys.all, projectId] as const,
  project: (projectId: string) => [...systemKeys.systems(projectId), "getProjectById"] as const,
  setting: (name: string, value: string) => [...systemKeys.all, name, value] as const,
};
